/**
 * Copyright (c) 2016-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { toIntlLanguage } from "@ndla/util";
import type { LocaleType } from "../interfaces";

const timeZone = "Europe/Oslo";

export const formatDate = (date: string, locale: LocaleType) => {
  return new Intl.DateTimeFormat(toIntlLanguage(locale), {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone,
  }).format(new Date(date));
};

export const formatTime = (date: string, locale: LocaleType) => {
  return new Intl.DateTimeFormat(toIntlLanguage(locale), {
    hour: "2-digit",
    minute: "2-digit",
    timeZone,
  }).format(new Date(date));
};

export const getNdlaRobotDateFormat = (date: Date) => {
  return new Intl.DateTimeFormat("en-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZone,
    hour12: false,
  })
    .format(date)
    .replace(",", "");
};
